<template>
  <div class="user-accounts">
    <base-combobox
      :service="$options.firmService"
      fetch-func="all"
      :fetch-params="{ archived: true }"
      label="Select firm to associate"
      :loading="loadingCombobox"
      @select="associate"
      ref="comboboxFirm"
    >
      <template #header="{ value }">
        <a @click="createFirm(value)">Add</a>
      </template>
    </base-combobox>
    <b-table :data="user.firmAssociations || []" :loading="loadingTable">
      <template slot-scope="props">
        <b-table-column field="name" label="Associated Firms">
          {{ props.row.firm ? props.row.firm.name : "" }}
        </b-table-column>
        <b-table-column field="actions" numeric>
          <b-button
            type="is-danger"
            size="is-small"
            @click="unassociate(props.row.firm || null)"
          >
            DELETE
          </b-button>
        </b-table-column>
      </template>
      <template slot="empty">
        <div class="content has-text-grey has-text-centered">
          <p>NO RECORDS FOUND</p>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { FirmService } from "@/services/firm.service";
import { UserService } from "@/services/user.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import BaseCombobox from "@/components/partials/BaseCombobox";

export default {
  firmService: FirmService,
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  components: {
    BaseCombobox
  },
  data: () => ({
    loadingCombobox: false,
    loadingTable: false
  }),
  methods: {
    async associate(organization) {
      if (!organization) return;

      this.loadingCombobox = true;

      try {
        const user = await UserService.createFirmAssociation(this.user.id, {
          firm_id: organization.id
        }).then(response => JsonDenormalizer.denormalize(response));

        this.$buefy.toast.open({
          message: "Firm been associated.",
          type: "is-info",
          position: "is-top-right"
        });

        this.user.firmAssociations = user.firmAssociations;
        // Clear combobox value
        this.$refs.comboboxFirm.clear();
      } catch (err) {
        this.$buefy.toast.open({
          message: "Failed to associate firm.",
          type: "is-danger",
          position: "is-top-right"
        });
      }

      this.loadingCombobox = false;
    },
    async unassociate(organization) {
      if (!organization) return;

      this.loadingTable = true;

      try {
        const user = await UserService.deleteFirmAssociation(
          this.user.id,
          organization.id
        ).then(response => JsonDenormalizer.denormalize(response));

        this.$buefy.toast.open({
          message: "Firm association been deleted.",
          type: "is-info",
          position: "is-top-right"
        });

        this.user.firmAssociations = user.firmAssociations;
      } catch (err) {
        console.error(err);
        this.$buefy.toast.open({
          message: "Failed to delete firm association.",
          type: "is-danger",
          position: "is-top-right"
        });
      }

      this.loadingTable = false;
    },
    createFirm(name) {
      this.$buefy.dialog.prompt({
        type: "is-dark",
        message: "Create and associate firm",
        inputAttrs: {
          value: name
        },
        confirmText: "Add",
        onConfirm: async value => {
          this.loadingCombobox = true;

          try {
            // Create firm
            const organization = await FirmService.store({
              name: value
            }).then(response => JsonDenormalizer.denormalize(response));

            // Reset combobox options
            await this.$refs.comboboxFirm.fetchOptions(1, false);

            // Associate created firm
            this.$refs.comboboxFirm.setSelected(organization);
          } catch (err) {}

          this.loadingCombobox = false;
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/persons/userAccounts.vue